import { defineMessages } from 'react-intl-next';
export var messages = defineMessages({
  title: {
    id: 'fabric.editor.ai.config.item.empty.bb.pr.description.title',
    defaultMessage: 'Create pull request description',
    description: 'Title for "Create pull request description" Atlassian Intelligence feature shown in editor typeahead and element browser.'
  },
  description: {
    id: 'fabric.editor.ai.config.item.empty.bb.pr.description.description',
    defaultMessage: 'Creates a pull request description with a summary of changes',
    description: 'Describes the "Create pull request description" Atlassian Intelligence feature shown in editor typeahead and element browser.'
  }
});